import MenuCustom from '@/components/ui/ui-react-antd/MenuCustom'
import { useMemo } from 'react'

const getSubmenuKeys = (items: any[]): string[] => {
  let keys: string[] = []
  items?.forEach((item) => {
    if (item?.children && item.children.length > 0) {
      keys.push(item.key)
      keys = keys.concat(getSubmenuKeys(item.children))
    }
  })
  return keys
}

const MenuLeft = ({ onChange, selectedKey, menu, collapsemenu }: any) => {
  const defaultOpenKeys = useMemo(() => getSubmenuKeys(menu), [menu])

  return (
    <MenuCustom
      onClick={onChange}
      selectedKeys={selectedKey}
      defaultOpenKeys={defaultOpenKeys}
      mode="inline"
      items={menu}
      className="menu-antd-user"
      theme="light"
      inlineCollapsed={collapsemenu}
    />
  )
}

export default MenuLeft
